import Vue from 'vue';
import { AppModule } from '@/modules/core/app/constants/app.constants';
import { getters } from '@/modules/core/app/helpers/store';
import { fromSnakeCaseToPascalCase } from '@/modules/core/app/helpers/StringHelper';

Object.keys(AppModule).forEach((key) => {
  const globalInstanceMethod = `$is${fromSnakeCaseToPascalCase(AppModule[key])}ModuleAvailable`;
  Vue.prototype[globalInstanceMethod] = () =>
    getters.session.getUserSettings()?.isModuleAvailable(AppModule[key]);
});
